import { Component, OnInit } from '@angular/core';
import { RootScopeService } from '../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../core/rootscope-declare';
import { Router } from '@angular/router';
import { HaloToastService } from '../../../core/halo-toast/halo-toast.service';
import { CommonUtil } from '../../../core/Utils/common-util';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-staff',
  templateUrl: './staff.component.html',
  styleUrls: ['./staff.component.scss'],
})
export class StaffComponent implements OnInit {
  rootScopeData: RootScopeDeclare;
  userPermission: boolean = false;
  constructor(
    private _rootScopeService: RootScopeService,
    private _amplitudeAnalytics: AmplitudeAnalyticsService,
    private _router: Router,
    private _toast: HaloToastService,
    private _cUtil: CommonUtil,
  ) { 

    
  }

  getRootScopeData(): void {
    this._rootScopeService.getRootScope().subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
  }

  setPageName(): void {
    this.rootScopeData.pageName = 'Facility - Staff';
  }

  ngOnInit(): void {
    this.getRootScopeData();
    this.setPageName();
    if(history.state.data){
      this.showToast(history.state.data);
    }
  }


  goToAddStaff(): void {
    this._router.navigate(['facility/staff', 'add', '']);
  }

  showToast(data: any): void{
    let msg:string =  this._cUtil.replaceValueAsHTMLOnTranslatedText('STAFF.ADDED.SUCCESS.MSG', [`<b>${data.email}</b>`, this._cUtil.translateText(data.managerType)]);
    if(data.type === '0'){
      msg = this._cUtil.replaceValueAsHTMLOnTranslatedText('FACILITY.NEW.USER.ADDED.AS.STAFF', [`<b>${data.email}</b>`, `<b>${data.email}</b>`, `<b>${data.facilityName}</b>`]);        
    }
    this._toast.creatToast(msg);
  }

  onUserPermission(userPermission: boolean) {
    this.userPermission = userPermission;
  }
}
